import { amendmentsManager, type IAgreementDetail } from '@inpart-io/padme-iap';
import { type NavigationGuardNext, type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';

import { AgreementOverviewTabs } from '../agreement-overview/constants/agreement-overview.constants';

const AmendmentOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ '@/pages/amendment-overview/amendment-overview-page.vue');
};

export const amendmentOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.AMENDMENT_OVERVIEW_PAGE,
    beforeEnter: async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void> => {
        const amendment = await amendmentsManager.getById(parseInt(to.params.id as string, 10), { properties: 'agreementDetail.agreement' });
        next({
            name: ROUTE_DATA.AGREEMENT_OVERVIEW_PAGE.name,
            params: { id: (amendment.agreementDetail as IAgreementDetail).agreement },
            query: { agreementTab: AgreementOverviewTabs.AMENDMENTS, selectedAmendment: to.params.id }
        });
    },
    components: {
        main: AmendmentOverview
    }
};
